module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-agriculture--cover.1b4dd75a.jpg";